(() => {
  const cfg = window.FF_CANDLE_UPSELL || {};
  const candleProductType = (cfg.candleProductType || "").toLowerCase();
  const cooldownMs = Number(cfg.cooldownMinutes || 0) * 60 * 1000;

  if (!candleProductType) {
    console.log("[FF upsell] no candleProductType configured");
    return;
  }

  const backdrop = document.getElementById("ff-upsell-backdrop");
  const modal = document.getElementById("ff-upsell-modal");
  const primaryBtn = document.getElementById("ff-upsell-primary");
  const variantRows = Array.from(
    document.querySelectorAll(".ff-upsell-variant")
  );
    const closeBtn = document.getElementById("ff-upsell-close");


  console.log("[FF upsell] DOM check:", {
    backdrop: !!backdrop,
    modal: !!modal,
    primary: !!primaryBtn,
    variants: variantRows.length
  });

   if (!backdrop || !modal || !primaryBtn || variantRows.length === 0) {
    console.log("[FF upsell] modal or variants missing, abort");
    return;
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      if (isProcessingAdd) return;
      console.log("[FF upsell] close (X) clicked → stay on cart");
      close(); // just hide modal, do NOT redirect
    });
  }

  const FLAG_KEY = "ff_candle_upsell_last_at_checkout";
  const UPSell_HEADER = "X-FF-Upsell";


  let pendingCheckoutUrl = null;
  let isHandlingCheckout = false;
  let isProcessingAdd = false;

  const canShow = () => {
    const t = Number(sessionStorage.getItem(FLAG_KEY) || 0);
    return Date.now() - t > cooldownMs;
  };
  const markShown = () => sessionStorage.setItem(FLAG_KEY, String(Date.now()));

  const open = () => {
    backdrop.style.display = "block";
    modal.style.display = "block";
  };
  const close = () => {
    backdrop.style.display = "none";
    modal.style.display = "none";
  };

  const goToCheckout = () => {
    const dest = pendingCheckoutUrl || "/checkout";
    console.log("[FF upsell] redirecting to checkout:", dest);
    window.location.href = dest;
  };

  const cartHasCandle = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return false;
    return cart.items.some((it) => {
      const pt = (it.product_type || "").toLowerCase();
      return pt === candleProductType;
    });
  };

  const fetchCart = async () => {
    try {
      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" }
      });
      if (!res.ok) {
        console.log("[FF upsell] cart.js non-200:", res.status);
        return null;
      }
      return res.json();
    } catch (e) {
      console.error("[FF upsell] cart.js failed", e);
      return null;
    }
  };

  const getSelections = () => {
    const selections = [];
    variantRows.forEach((row) => {
      const id = row.getAttribute("data-variant-id");
      const valueEl = row.querySelector(".ff-upsell-qty-value");
      if (!id || !valueEl) return;
      const qty = Number(valueEl.textContent.trim() || "0");
      if (qty > 0) {
        selections.push({ id: Number(id), quantity: qty });
      }
    });
    return selections;
  };

  const getTotalQty = () => {
    return getSelections().reduce((sum, item) => sum + item.quantity, 0);
  };

  const refreshPrimaryButton = () => {
    const total = getTotalQty();
    if (total > 0) {
      primaryBtn.textContent = "להוסיף את הנרות להזמנה";
      primaryBtn.setAttribute("data-mode", "add");
    } else {
      primaryBtn.textContent = "להמשיך לתשלום בלי נר";
      primaryBtn.setAttribute("data-mode", "skip");
    }
  };

  // Initialise quantities and buttons
  variantRows.forEach((row) => {
    const dec = row.querySelector(".ff-upsell-qty-dec");
    const inc = row.querySelector(".ff-upsell-qty-inc");
    const val = row.querySelector(".ff-upsell-qty-value");

    if (!dec || !inc || !val) return;

    const update = (delta) => {
      const current = Number(val.textContent.trim() || "0");
      let next = current + delta;
      if (next < 0) next = 0;
      if (next > 10) next = 10; // simple hard cap
      val.textContent = String(next);
      refreshPrimaryButton();
    };

    dec.addEventListener("click", () => update(-1));
    inc.addEventListener("click", () => update(+1));
  });

  refreshPrimaryButton();

  const addSelectedCandles = async (items) => {
    console.log("[FF upsell] adding candles", items);
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        [UPSell_HEADER]: "1"
      },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error("candle add failed");
    return res.json();
  };

  // Backdrop click = behave like skip (no candles)
  backdrop.addEventListener("click", () => {
    if (isProcessingAdd) return;
    console.log("[FF upsell] backdrop clicked → checkout without candles");
    close();
    goToCheckout();
  });

  // Primary button click: skip or add+checkout
  primaryBtn.addEventListener("click", async () => {
    if (isProcessingAdd) return;

    const mode = primaryBtn.getAttribute("data-mode") || "skip";
    const selections = getSelections();

    if (mode === "skip" || selections.length === 0) {
      console.log("[FF upsell] primary in skip mode → checkout");
      close();
      goToCheckout();
      return;
    }

    // mode === "add"
    try {
      isProcessingAdd = true;
      primaryBtn.disabled = true;

      await addSelectedCandles(selections);
      markShown();
      close();
      goToCheckout();
    } catch (err) {
      console.error("[FF upsell] add candles error", err);
      close();
      goToCheckout();
    } finally {
      isProcessingAdd = false;
      primaryBtn.disabled = false;
    }
  });

  // Intercept checkout triggers
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'a[href*="/checkout"]'
  ].join(",");

  document.addEventListener(
    "click",
    async (event) => {
      const trigger = event.target.closest(CHECKOUT_SELECTOR);
      if (!trigger) return;

      console.log("[FF upsell] checkout click detected", trigger);

      if (isHandlingCheckout) {
        console.log("[FF upsell] already handling checkout");
        return;
      }

      if (!canShow()) {
        console.log("[FF upsell] cooldown active, allow normal checkout");
        return;
      }

      event.preventDefault();
      isHandlingCheckout = true;

      if (trigger instanceof HTMLAnchorElement && trigger.href) {
        pendingCheckoutUrl = trigger.href;
      } else {
        pendingCheckoutUrl = "/checkout";
      }

      const cart = await fetchCart();

      if (cart && cartHasCandle(cart)) {
        console.log("[FF upsell] cart already has candle, skip popup");
        isHandlingCheckout = false;
        goToCheckout();
        return;
      }

      console.log("[FF upsell] showing upsell modal now");
      markShown();
      open();
      isHandlingCheckout = false;
    },
    true
  );
  

  console.log("[FF upsell] initialized");
})();
